import image from "@/assets/blog/pdf_img.png";

// The published PDF material is part of the blog, but not the articles API.
// Both the full blog and its homepage preview use this same entry.
export const blogGuide = {
  id: "support-guide",
  slug: "how-to-support-yourself",
  image,
  titleKey: "blog.howToSupportYourself",
  excerptKey: "blog.psychologistsGuide",
  formatKey: "blog.pdf",
} as const;
